import React, { memo } from 'react'
import { Stack } from '@mui/material'

import Text from './Text'

const LabelValue = ({
  label,
  value,
  hint,
  fontSize = 1.25,
  sx,
  valueProps = {}
}) => {
  fontSize = `${fontSize}rem`
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={0.8}
      alignItems='baseline'
      sx={sx}
    >
      <Text label={`${label}:`} variant='body1' sx={{ fontSize }} />
      <Text
        label={value}
        variant='body1'
        fontWeight={700}
        sx={{ fontSize }}
        color='primary.main'
        {...valueProps}
      />
      {hint}
    </Stack>
  )
}

export default memo(LabelValue)
